// src/i18n/config.js
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import HttpBackend from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";


/**
 * Debe coincidir con ALLOWED_LANGS del backend
 */
const SUPPORTED_LANGS = ["es", "en"];

/**
 * Debe coincidir con ALLOWED_NS del backend (sin .json)
 */
const NAMESPACES = [
  "common",
  "aboutUs",
  "home",
  "settings",
  "search",
  "privacyPolicy",
  "loginPage",
  "registerPage",
  "resetPassword",
  "passwordRecovery",
  "editProfile",
  "logoutPage",
  "myProfile",
  "menu",
  "permissionsGuide",
  "userGuide",
];

i18n
  .use(HttpBackend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    debug: process.env.NODE_ENV === "staging",

    // Idioma por defecto si no se detecta o si falla carga
    fallbackLng: "es",
    supportedLngs: SUPPORTED_LANGS,

    // Namespaces
    ns: NAMESPACES,
    defaultNS: "common",

    returnNull: false,
    returnEmptyString: false,

    interpolation: {
      escapeValue: false,
    },

    backend: {
      loadPath: `/locales/{{lng}}/{{ns}}.json`,
    },

    detection: {
      order: ["querystring", "localStorage", "navigator"],
      lookupQuerystring: "lng",
      caches: ["localStorage"],
    },

    react: {
      useSuspense: true,
    },
  });

export default i18n;